import { render, staticRenderFns } from "./reminderDialog.vue?vue&type=template&id=421b3e6c&scoped=true&"
import script from "./reminderDialog.vue?vue&type=script&lang=js&"
export * from "./reminderDialog.vue?vue&type=script&lang=js&"
import style0 from "./reminderDialog.vue?vue&type=style&index=0&id=421b3e6c&scoped=true&lang=css&"
import style1 from "./reminderDialog.vue?vue&type=style&index=1&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "421b3e6c",
  null
  
)

export default component.exports